import { render, staticRenderFns } from "./OrganizationJobs.vue?vue&type=template&id=203c6dfe&"
import script from "./OrganizationJobs.vue?vue&type=script&lang=js&"
export * from "./OrganizationJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports